import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './moretoloveallproducts.css';

export default class MoreToLoveAllProducts extends Component {
    render() {
        return (
            <>
            <div className="more-to-love-all-products-com-webversion-main-sectionx">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="more-to-love-all-produc-wexv-dot-main-sec-bboxx-web-version">
                                <div className="more-to-love-all-produc-dott-ccm-dealmmnnff-bb-web-verrsn">
                                    <p><span><img src={require('../../../assets/moreto-love-all-prod-icon.svg')} alt="orponbd online shop"/></span> More To Love</p>
                                </div>
                                {/* Single Row Start */}
                                <div className="row more-to-love-all-produc-com-delproj-rww-webb-versnn">
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-1.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-2.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-3.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-4.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-5.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-6.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* Single Row End */}
                                {/* Single Row Start */}
                                <div className="row more-to-love-all-produc-com-delproj-rww-webb-versnn">
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-7.png')} alt="orponbd online shop"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-14.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-15.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-8.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/more-all-products-9.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-6">
                                        <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvesnn">
                                            <Link to="/#">
                                                <div className="more-to-love-all-produc-ddot-cmm-snnggl-prodct-web-vvesnn-img">
                                                    <img src={require('../../../assets/item-18.png')} alt="orponbd global collections"/>
                                                </div>
                                                <div className="more-to-love-all-produc-web-ddot-cmm-snnggl-prodct-web-vvrsn-ttxt">
                                                    <p>Product Name In Two Line maximum</p>
                                                    <h3><span>৳</span> 1200</h3>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/* Single Row End */}

                                <div className="moreto-love-web-version-view-more-btn text-center">
                                    <button>View More <span><i className="fas fa-angle-down"></i></span></button>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }
}
